import { SET_PLAYER_ANALYTICS_CONSENT, WEBSITE } from 'common/actions/website';

const initialState = {
  isLoading: true,
  gavePlayerAnalyticsConsent: undefined, // undefined means we don't know yet
};

export const websiteReducer = (state = initialState, action) => {
  switch (action.type) {
    case WEBSITE.FETCH.SUCCESS:
      return {
        ...state,
        ...action.payload.website,
        isLoading: false,
      };
    case SET_PLAYER_ANALYTICS_CONSENT:
      return {
        ...state,
        gavePlayerAnalyticsConsent: action.payload.gaveConsent,
      };

    default:
      return state;
  }
};
